import { AxiosError } from "axios";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";

const STATUS_UNAVAILABLE_FOR_LEGAL_REASONS = 451;

export const useIllegalSearchCatcher = <T>(fetch: (page?: number) => Promise<T>) => {
  const navigate = useNavigate();

  return useCallback(async (page?: number) => {
    try {
      return await fetch(page);
    } catch (e) {
      const status = (e as AxiosError).response?.status;
      if (status !== STATUS_UNAVAILABLE_FOR_LEGAL_REASONS) {
        throw e;
      }

      navigate(routes.searchWarningPage());
    }
  }, [fetch]);
};

